var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"voc-breadcrumb"},[_c('el-breadcrumb',{attrs:{"separator":"/"}},_vm._l((_vm.breadcrumbList),function(item,index){return _c('el-breadcrumb-item',{key:item.code,attrs:{"to":index === 0 ? undefined : { name: item.code }}},[_vm._v(_vm._s(_vm.$lang === 'zh-cn' ? item.name : item.alias))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }